import PageLayout from './PageLayout';

export default PageLayout;



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Postcard/Components/PageLayout/index.ts